const SENSITIVE_KEYS = [
  "password",
  "newPassword",
  "currentPassword",
  "passwordHash",
  "passwordSalt",
  "token",
  "accessToken",
  "refreshToken",
  "idToken",
  "access_token",
  "refresh_token",
  "secret",
  "clientSecret",
  "client_secret",
  "apiKey",
  "privateKey"
];

const REDACTED = "[REDACTED]";

const scrubObject = (value) => {
  if (Array.isArray(value)) {
    return value.map(scrubObject);
  }

  if (!value || typeof value !== "object") {
    return value;
  }

  const entries = Object.entries(value).map(([key, val]) => {
    if (SENSITIVE_KEYS.includes(key)) {
      return [key, REDACTED];
    }
    return [key, scrubObject(val)];
  });
  return Object.fromEntries(entries);
};

export const sentryBeforeSend = (event) => {
  if (!event) {
    return event;
  }

  return {
    ...event,
    ...(event.request ? { request: scrubObject(event.request) } : {}),
    ...(event.extra ? { extra: scrubObject(event.extra) } : {}),
    ...(event.contexts ? { contexts: scrubObject(event.contexts) } : {})
  };
};

export { scrubObject, SENSITIVE_KEYS };
